import { render, staticRenderFns } from "./touristQYData.vue?vue&type=template&id=69c57652&scoped=true&"
import script from "./touristQYData.vue?vue&type=script&lang=js&"
export * from "./touristQYData.vue?vue&type=script&lang=js&"
import style0 from "./touristQYData.vue?vue&type=style&index=0&id=69c57652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c57652",
  null
  
)

export default component.exports